import { z } from 'zod';

import { FormValidation } from '@/_shared';

export const checkoutFormSchema = z
  .object({
    first_name: z.string().min(2),
    last_name: z.string().min(2),
    email: FormValidation.email,
    phone: FormValidation.mobilePhone,
    state: FormValidation.selectInput(),
    zip_code: FormValidation.requiredString,
    password: z.string().min(8),
    confirm_password: z.string().min(8),

    name: z
      .string({
        required_error: 'Name is required',
      })
      .nonempty(),
    card_number: FormValidation.creditCard,
    expiry: z
      .string({
        required_error: 'Expiry is required',
        invalid_type_error: 'Expiry is required',
      })
      .length(4),
    cvv: FormValidation.cvv,
  })
  .refine((data) => data.password === data.confirm_password, {
    message: 'The new password fields do not match',
    path: ['repeat_new_password'],
  });
export type CheckoutFormSchema = z.infer<typeof checkoutFormSchema>;
